import { GoogleSheetTemplate } from '../actions/googleSheetsActions';
import {
  CLEAR_ALL_DATA,
  UPDATE_GOOGLE_SHEETS_TEMPLATES
} from '../actionTypes';

export interface StateType {
  templates: GoogleSheetTemplate[]
}

const INITIAL_STATE: StateType = {
  templates: []
};

const reducer = (state = INITIAL_STATE, action: { type: string, data: any }): StateType => {
  switch (action.type) {
    case UPDATE_GOOGLE_SHEETS_TEMPLATES:
      return {
        ...state,
        templates: action.data || []
      };
    case CLEAR_ALL_DATA:
      return INITIAL_STATE;

    default: return state;
  }
};

export default reducer;
